export const envoyerEmailOuVerification = (email, contenu = null, type) => {
    console.log(email)
    if (!email) {
        alert("Veuillez entrer une adresse email valide.");
        return;
    }

    const body = type === "message" ? { email, contenu } : { email };
    
    fetch("/api/send-email-or-link", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...body, type }),
    })
    .then((response) => response.json())
    .then((data) => {
        if (data.message && type==="verification") {
            alert(data.message);
        } else {
            
        }
    })
    .catch((error) => {
        console.error("Erreur lors de l'envoi de l'email :", error);
        alert("Erreur lors de l'envoi de l'email.");
    });
};
